import React from "react";
import Globals from "./../api";
import { Helmet } from "react-helmet";  
import CategoryListing from "./categorylisting/categorylisting";
import BlockListing from "./blocklisting/blocklisting";
import axios from "axios";
// GPT.enableSingleRequest();
//Gpt.enableSingleRequest();
export default class ListingMiddleWare extends React.Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
    this.setStateOfParent.bind(this);
    this.state = {
       data : [],
       videos : [],
       meta : [] ,
       title : [],
       meta_keywords : [],
       meta_description : [],
       PhotoGallery : [],
       CricketData :[],
       categoryData: [],
       loadUrlData: [],
       page: 1,
       pageType : [],
       Coronadata :[],
       Horoscope : [],
       navigationMenu: [],
       AdData : [],
       Rightbar :[]
      
     };
  }

  handler = (data) => {
    this.setState({
      categoryData: data
    })
  }
  getVideos(){
    const url= Globals.language_based_api+'%2Fvideos';
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        
        this.setState({
          videos : data.Contents[2].out.list
        })
    })   
  }
  getRightbar(){
    const url= Globals.Rightbar_api+window.location.pathname;
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        
        this.setState({
          Rightbar : data.Contents[0]
        })
    })   
  }
  getPhotoGallery(){
    const url= Globals.language_based_api+'%2Fphoto-gallery';
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        
        this.setState({
            PhotoGallery : data.Contents
        })
    })   
  }
  getCricketUpdate(){
    const url= Globals.Cricket_update_api;
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        this.setState({
          CricketData : data.CurrentMatches,
          
        })
    })   
  }
  getCoronaTracker(){
    const url= 'https://ws-en.webdunia.com/json/tracker-api/get-tracker?lang=hi';
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
              
                this.setState({
                  Coronadata : data.results
                })
               // console.log("corona "+data);
            })   
  }
  getHoroscope() {
    // console.log('api at header' + Globals.language_based_api);
        const url= Globals.language_based_api+'%2Fhome-page';
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
          
            this.setState({
              Horoscope : data.Contents
            })
        }) 
      }
      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].ROS
                    })
                    
                }) 
                
      }
      setStateOfParent = (optionId,GroupId,PollId) => {
        var bodyFormData = new FormData();
        bodyFormData.append('pollID', PollId);
        bodyFormData.append('groupID', GroupId);
        bodyFormData.append('optionID', optionId);
            axios({
                method : "post",
                url :Globals.poll_api,
                data: bodyFormData
            })
            .then(response => response)
             .then(data => this.setState({ PollResult: data.data  })); 
          }
componentDidMount() {
    // console.log('api at header' + Globals.language_based_api);
    let url = window.location.pathname;
    const categoryListURL = Globals.language_based_api + url;
        fetch(categoryListURL)
        .then((res) => res.json())
        .then((data) => {
          
            this.setState({
              data : data.Contents,
              meta : data.Meta ,
              title : data.Title,
              meta_keywords : data.Meta.keywords.Attributes.content,
              meta_description : data.Meta.description.Attributes.content,
              categoryData: data.Contents,
              loadUrlData: data.Contents[3].PageUrl,
              nextPage: false,
              pageType : data.PageType,
              navigationMenu : data.Contents[1].Items
    
            })
        }) 
    this.getVideos();  
    this.getCricketUpdate();
    this.getPhotoGallery();
    this.getCoronaTracker();
    this.getHoroscope();
    this.getAds();
    this.getRightbar();
      }

  render() {
   // console.log(this.state)
    let props = {
      data : this.state.data,
      meta : this.state.Meta ,
      title : this.state.Title,
      meta_keywords : this.state.meta_keywords,
      meta_description : this.state.meta_description,
      videos : this.state.videos,
      CricketData : this.state.CricketData,
      PhotoGallery : this.state.PhotoGallery,
      categoryData:this.state.categoryData,
      loadUrlData: this.state.loadUrlData,
      nextPage:this.state.nextPage,
      pageType : this.state.pageType,
      handler : this.handler,
      Coronadata : this.state.Coronadata, 
      Horoscope : this.state.Horoscope,
      navigationMenu : this.state.navigationMenu,
      AdData : this.state.AdData, 
      setStateOfParent : this.setStateOfParent,
      Rightbar : this.state.Rightbar
      };
    let Pagetype = this.state.pageType;
    return (
        <>
           {(() => {
            if (Object.keys(this.state.data).length> 0 ) {
            return (
              <>
              {(() => {
                if (Pagetype == "Listing" ) {
                  return (
                    <CategoryListing  {...props}/>
                  )
                } else  {
                  return (
                    <BlockListing {...props}/>
                  )
                }
              })()}
              </>
            )
          }})()} 
      </>
    );
  }
}
